export default "__VITE_ASSET__B$Qomd5j__"